import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import Back from '../../../components/common/Back';
import { fetchAddMealList, fetchMealItemDetail, addIngredientToMealPlan, fetchIngredientsForCustomize, deleteIngredientFromMealPlan, clearMessage, updateIngredientQuantity } from '../../../redux/slices/customer/mealPlanSlice';
import { calculateCalories, formatNumber } from '../../../utils';
import Pagination from '../../../components/common/Pagination';
import '../../../global.css';
import { useParams } from 'react-router-dom';

const CustomizeMeal = () => {
  const dispatch = useDispatch();
  const { mealId } = useParams();
  const { mealDetail, customizeMealList, customizeMealListCurrentPage, customizeMealListTotalPages } = useSelector((state) => state.mealPlan);
  const [totals, setTotals] = useState({ protein: 0, carb: 0, fat: 0, calories: 0 });
  const [ingredientQuantities, setIngredientQuantities] = useState({});
  const [ingredientQuantitiesTop, setIngredientQuantitiesTop] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [totalCalories, setTotalCalories] = useState(0);

  useEffect(() => {
      dispatch(clearMessage());
  }, []); 

  useEffect(() => {
    const p = { category: "", term: "", page: 1, perPage: 10 };
    dispatch(fetchAddMealList(p));
    dispatch(fetchMealItemDetail(mealId));
    const params = {term: '', page: 1};  
    dispatch(fetchIngredientsForCustomize(params));
  }, [dispatch]);

  const handlePageChange = (page) => {
  	const params = {term: searchTerm, page: page};  
    dispatch(fetchIngredientsForCustomize(params));
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    const params = {term: e.target.value, page: 1};  
    dispatch(fetchIngredientsForCustomize(params));
  };

useEffect(() => {
  if (mealDetail && mealDetail.ingredients) {
    const newTotals = { protein: 0, carb: 0, fat: 0, calories: 0 };
    JSON.parse(mealDetail.ingredients).forEach((ingredient, index) => {
      const quantity = ingredientQuantitiesTop?.[index] || ingredient.quantity || 1;

      newTotals.protein += 
        (Number(ingredient.protein ?? ingredient.protein_per_unit) || 0) * quantity;
      newTotals.carb += 
        (Number(ingredient.carb ?? ingredient.carb_per_unit) || 0) * quantity;
      newTotals.fat += 
        (Number(ingredient.fat ?? ingredient.fat_per_unit) || 0) * quantity;
      newTotals.calories += 
        (Number(ingredient.calories) || 0) * quantity;
    });
    setTotals(newTotals);

  }
}, [mealDetail, ingredientQuantitiesTop]);



useEffect(() => {
  if (mealDetail && mealDetail.ingredients) {
   
      // Recalculate total calories on key up
    const updatedIngredients = JSON.parse(mealDetail.ingredients).map((ingredient, i) => ({
        ...ingredient,
        quantity: ingredient.quantity ?? 1
    }));

    setTotalCalories(calculateCalories(updatedIngredients));

  }
}, [mealDetail]);




  const handleAddIngredient = (ingredient) => {
    const quantity = ingredientQuantities[ingredient.id] || ingredient.quantity || 1;
    const payload = {
      mealId: mealDetail.id,
      name: ingredient.ingredient_name,
      unit: ingredient.unit,
      quantity,
      protein: ingredient.protein_per_unit,
      carb: ingredient.carb_per_unit,
      fat: ingredient.fat_per_unit,
      calories: calculateCalories([{ ...ingredient, quantity }])
    };
    dispatch(addIngredientToMealPlan(payload)).then(() => {
      dispatch(fetchMealItemDetail(mealDetail.id));
    });
  };

 

const handleQuantityChange = (id, value) => {
  setIngredientQuantities((prev) => ({
    ...prev,
    [id]: value,  // Allow empty string without converting it
  }));
};


const handleQuantityChangeTop = (index, value) => {
    const newQuantities = { ...ingredientQuantitiesTop, [index]: Number(value) || '' };
    setIngredientQuantitiesTop(newQuantities);

    // Recalculate total calories on key up
    const updatedIngredients = JSON.parse(mealDetail.ingredients).map((ingredient, i) => ({
        ...ingredient,
        quantity: newQuantities[i] ?? ingredient.quantity ?? 1
    }));

    setTotalCalories(calculateCalories(updatedIngredients));
};

  const handleQuantityChangeTopBlur = (id, value) => {
    dispatch(updateIngredientQuantity({ mealId: mealDetail.id, deleteIndex: id, quantity:value  }));
  };

  const handleDeleteIngredient = (index) => {
    setIngredientQuantitiesTop((prev) => {
    const updated = { ...prev };
    delete updated[index]; // Remove the ingredient entry
    return updated;
  });

    dispatch(deleteIngredientFromMealPlan({ mealId: mealDetail.id, deleteIndex: index }));
  };

  useEffect(() => {
    if (customizeMealList.length > 0) {
      const defaultQuantities = customizeMealList.reduce((acc, ingredient) => {
        acc[ingredient.id] = 1;
        return acc;
      }, {});
      setIngredientQuantities(defaultQuantities);
    }
  }, [customizeMealList]);

  return (
    <Layout>
      <main className="main page-add-meal">
        <header className="main-head flex justify-between align-center">
          <div className="main-head flex pb-0">
            <h1 className="greet-user-text">Add Meal to Customize</h1>

          </div>
           <div className="ms-auto">
            <Back />
          </div>
        </header>
        <div className="main-content flex justify-between flex-col-rev-mob">
          <div style={{ width: '100%' }}>
            <div className="meals-container meals-added pt-0">
              <h2>Current Ingredients</h2>

              <div className="card responsive-table-container mt-4 p-0">
                <table className="admin-table table-add-meal">
                  <thead>
                    <tr>
                      <th>Name</th><th>Quantity</th><th>Unit</th><th>Protein</th><th>Carb</th><th>Fat</th><th>Calories</th><th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mealDetail && JSON.parse(mealDetail.ingredients).map((ingredient, index) => (
                      <tr key={index}>
                        <td>{ingredient.name || ingredient.ingredient_name}</td> {/* Assuming name is a string, no .toFixed() here */}
                 
                        <td>
  <input
    type="number"
    placeholder="Qty"
    value={ingredientQuantitiesTop[index] !== undefined ? ingredientQuantitiesTop[index] : ingredient.quantity}
    onChange={(e) => handleQuantityChangeTop(index, e.target.value)}
    onBlur={(e) => handleQuantityChangeTopBlur(index, e.target.value)}
  />
</td>

<td>{ingredient.unit}</td> {/* Displaying unit directly */}
<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber((
    isNaN(
      (Number(ingredient.protein ?? ingredient.protein_per_unit) ?? 0) *
      (ingredientQuantitiesTop[index] || ingredient.quantity || 1)
    )
      ? 0
      : (Number(ingredient.protein ?? ingredient.protein_per_unit) ?? 0) *
        (ingredientQuantitiesTop[index] ?? ingredient.quantity ?? 1)
  ))} g
  </span>
</td>
<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
   {formatNumber((
    isNaN(
      (Number(ingredient.carb ?? ingredient.carb_per_unit) ?? 0) *
      (ingredientQuantitiesTop[index] ?? ingredient.quantity ?? 1)
    )
      ? 0
      : (Number(ingredient.carb ?? ingredient.carb_per_unit) ?? 0) *
        (ingredientQuantitiesTop[index] ?? ingredient.quantity ?? 1)
  ))} g
   </span>
</td>
<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber((
      isNaN(
      (Number(ingredient.fat ?? ingredient.fat_per_unit) ?? 0) *
      (ingredientQuantitiesTop[index] ?? ingredient.quantity ?? 1)
    )
      ? 0
      : (Number(ingredient.fat ?? ingredient.fat_per_unit) ?? 0) *
        (ingredientQuantitiesTop[index] ?? ingredient.quantity ?? 1)
  ))} g
  </span>
</td>



<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
{formatNumber(calculateCalories([{ ...ingredient, quantity: ingredientQuantitiesTop[index] ?? ingredient.quantity ?? 1 }]))} kcal
</span>
</td>

                        <td>
                          <button className="reset-trainin btn-save-meal btn-save-meal-min" onClick={() => handleDeleteIngredient(index)}>Delete Ingredient</button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td><strong>Totals</strong></td>
                      <td colSpan="2"></td>
                      <td><span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>{Number(totals.protein).toFixed(2)} g</span></td>
                      <td><span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>{Number(totals.carb).toFixed(2)} g</span></td>
                      <td><span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>{Number(totals.fat).toFixed(2)} g</span></td>
                      <td><span style={{whiteSpace: 'nowrap',display: 'inline-block'}}> {formatNumber(totalCalories)} kcal</span></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h2>Add New Ingredients</h2>

              <div className="form-group position-relative search_field" style={{ margin: 0, backgroundColor:'white' }}>
                  <input
                    id="search"
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{border:'none',outline:'none'}}
                  />
                  <i className="fa-solid fa-magnifying-glass position-absolute search_field_class"></i>
                </div>
                <br />

              <div className="card responsive-table-container mt-4 p-0">              

                <table className="admin-table table-add-meal">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Quantity</th>
                      <th>Unit</th>
                      <th>Protein</th>
                      <th>Carb</th>
                      <th>Fat</th>
                      <th>Calories</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customizeMealList.map((ingredient) => (
                      <tr key={ingredient.id}>
                        <td>{ingredient.ingredient_name}</td>



                                               <td>
  <input
    type="number"
    placeholder="Qty"
    value={ingredientQuantities[ingredient.id] || ''}
    onChange={(e) => handleQuantityChange(ingredient.id, e.target.value)}
  />
</td>
<td>{ingredient.unit || 'N/A'}</td>

<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(ingredient.protein_per_unit 
    ? (Number(ingredient.protein_per_unit) * (ingredientQuantities[ingredient.id] ?? 0)).toFixed(2) 
    : '0.00')} g
   </span>
</td>
<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(ingredient.carb_per_unit 
    ? (Number(ingredient.carb_per_unit) * (ingredientQuantities[ingredient.id] ?? 0)).toFixed(2) 
    : '0.00')} g
     </span>
</td>
<td>
  <span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {formatNumber(
    ingredient.fat_per_unit
      ? (Number(ingredient.fat_per_unit) * (ingredientQuantities[ingredient.id] ?? 0)).toFixed(2)
      : '0.00'
  )}{' '}
  g
  </span>
</td>


<td>
<span style={{whiteSpace: 'nowrap',display: 'inline-block'}}>
  {ingredientQuantities[ingredient.id] 
    ? calculateCalories([{ 
        ...ingredient, 
        protein: ingredient.protein_per_unit, 
        carb: ingredient.carb_per_unit, 
        fat: ingredient.fat_per_unit, 
        quantity: ingredientQuantities[ingredient.id] 
      }]).toFixed(2) 
    : '0.00'} kcal
    </span>
</td>



                        <td><button className="btn-save-meal-min btn-save-meal" onClick={() => handleAddIngredient(ingredient)}>Add</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Pagination currentPage={customizeMealListCurrentPage} totalPages={customizeMealListTotalPages} onPageChange={handlePageChange} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default CustomizeMeal;